export function withServiceDomain(url: string, serviceDomain: string): string {
    if (!url || !serviceDomain) {
        return url;
    }

    const hashIndex = url.indexOf('#');
    const baseUrl = hashIndex === -1 ? url : url.slice(0, hashIndex);
    const fragment = hashIndex === -1 ? '' : url.slice(hashIndex);

    if (/(?:[?&])sd(?:=|&|$)/.test(baseUrl)) {
        return url;
    }

    const separator = baseUrl.indexOf('?') === -1
        ? '?'
        : /[?&]$/.test(baseUrl) ? '' : '&';

    return baseUrl + separator + 'sd=' + encodeURIComponent(serviceDomain) + fragment;
}
